import fetch from '../../../../api/profiles'

export default {
  updateProfileList: async ({commit}) => {
    commit('setLoading', true)
    commit('setCurrentStep', {code: 'list', payload: null})
    commit('setProfileTypeList', await fetch.profileTypeList())
    commit('setProfileList', await fetch.profileList())
    commit('setLoading', false)
  },
  saveProfile: async ({commit, getters, dispatch}) => {
    commit('setLoading', true)
    const data = {
      typeId: getters.getCreateTypeId,
      profileId: getters.getEditProfileId,
      fields: getters.getProfileProps,
      name: getters.getProfileName.value
    }

    await fetch.profileSave(data)

    commit('setCreateTypeId', null)
    commit('setEditProfileId', null)
    commit('setProfileProps', [])
    commit('setProfileName', {
      ...getters.getProfileName,
      value: ''
    })
    dispatch('updateProfileList')
  },
  editProfile: async ({commit, getters}, id) => {
    const selectedProfile = getters.getProfileList.find(e => e.id === id)
    commit('setLoading', true)
    commit('setEditProfileId', id)
    commit('setCurrentStep', {code: 'edit', payload: null})
    commit('setProfileName', {
      ...getters.getProfileName,
      value: selectedProfile.name
    })
    commit('setProfileProps', await fetch.profilePropsValueList(id))
    commit('setLoading', false)
  },
  removeProfile: async ({commit, dispatch}, id) => {
    commit('setLoading', true)
    await fetch.profileRemove(id)
    dispatch('updateProfileList')
  },
  chooseCreateType: async ({commit}, id) => {
    commit('setLoading', true)
    commit('setCreateTypeId', id)
    commit('setCurrentStep', {code: 'create', payload: null})
    commit('setProfileProps', await fetch.profilePropsValueDefaultList(id))
    commit('setLoading', false)
  },
  checkInn: async ({commit}, inn) => {
    commit('setLoading', true)
    const data = await fetch.checkInn(inn)
    commit('setLoading', false)
    return !data.isHaveInn
  },
  cancelEdit: ({commit, getters}) => {
    commit('setLoading', true)
    commit('setCurrentStep', {code: 'list', payload: null})
    commit('setCreateTypeId', null)
    commit('setEditProfileId', null)
    commit('setProfileProps', [])
    commit('setProfileName', {
      ...getters.getProfileName,
      value: ''
    })
    commit('setLoading', false)
  }
}



// WEBPACK FOOTER //
// ./src/components/store/modules/profile/actions.js